import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import { BrowserRouter as Router, Route, Link } from "react-router-dom";

import style from './style.scss';

export default class Menu extends Component {

  constructor(props) {
    super(props);

    this.state = {
      current_page: '',
      show: false
    };

    this.setPage = this.setPage.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);

  }

  setPage(page) {
    this.setState({
      current_page: page
    });

    this.toggleMenu();

  }

  toggleMenu() {

    this.setState({
      show: !this.state.show
    });

  }

  menuButton() {
    return (
      <div onClick={this.toggleMenu} className="main_menu__button">
        Меню
      </div>
    );
  }

  menuList() {

    const {app_data, history} = this.props;
    const role = app_data.roles[app_data.user.role_id];

    const calls_access = role.access.calls;
    const leads_access = role.access.leads;
    const callbacks_access = role.access.callbacks;
    const deliveries_access = role.access.deliveries;


    const active_classes = {
      calls: (this.state.current_page == '') ? 'active' : '',
      leads: (this.state.current_page == 'leads') ? 'active' : '',
      statistics: (this.state.current_page == 'statistics') ? 'active' : '',
      callbacks: (this.state.current_page == 'callbacks') ? 'active' : '',
      deliveries: (this.state.current_page == 'deliveries') ? 'active' : '',
      deliveries_statistics: (this.state.current_page == 'deliveries_statistics') ? 'active' : '',
    };

    return (
      <div>

        <div onClick={this.toggleMenu} className="main_menu__overlay"></div>

        <div className="main_menu__list">

          {calls_access && <Link to="/">
            <div className={`main_menu__list__item ${active_classes.calls}`} onClick={() => {
              this.setPage('');
            }}>Звонки</div>
          </Link>}

          {
            leads_access && <Link to="/leads">
              <div className={`main_menu__list__item ${active_classes.leads}`} onClick={() => {
                this.setPage('leads');
              }}>Обращения</div>
            </Link>
          }

          {
            leads_access && <Link to="/statistics">
              <div className={`main_menu__list__item ${active_classes.statistics}`} onClick={() => {
                this.setPage('statistics');
              }}>Статистика</div>
            </Link>
          }

          {
            callbacks_access && <Link to="/callbacks">
              <div className={`main_menu__list__item ${active_classes.callbacks}`} onClick={() => {
                this.setPage('callbacks');
              }}>Лист обзвона</div>
            </Link>
          }


          <Link to="/deliveries">
            <div className={`main_menu__list__item ${active_classes.deliveries}`} onClick={() => {
              this.setPage('deliveries');
            }}>Доставки</div>
          </Link>

          {
            deliveries_access && <Link to="/deliveries_statistics">
              <div className={`main_menu__list__item ${active_classes.deliveries_statistics}`} onClick={() => {
                this.setPage('deliveries_statistics');
              }}>Статистика доставок</div>
            </Link>
          }

          <a href="/logout">
            <div className={`main_menu__list__item`}>Выход</div>
          </a>
        </div>
      </div>
    );
  }

  render() {

    return (
      <div>
        {this.state.show ? this.menuList() : this.menuButton()}
      </div>
    );
  }

}


